import {
  FaBusAlt,
  FaCashRegister,
  FaThLarge,
} from 'react-icons/fa';
import { FaPeopleGroup } from 'react-icons/fa6';
import { IoTicket } from 'react-icons/io5';
import { MdChecklist, MdOutlineSell } from 'react-icons/md';
import { PiHandDeposit } from 'react-icons/pi';
import { BiCreditCard, BiSolidReport } from 'react-icons/bi';
import { HiOutlineClipboardDocumentList } from 'react-icons/hi2';
import { RiDashboardLine } from 'react-icons/ri';
import { BsCreditCard2Back } from 'react-icons/bs';
import { TbReportAnalytics } from 'react-icons/tb';

export const navigationConfig = {
  'FMPS-ADMIN': [
    { to: '/admin', icon: FaThLarge, label: 'Dashboard', end: true },
    { to: '/products', icon: IoTicket, label: 'Products' },
    { to: '/sales/sessions', icon: MdOutlineSell, label: 'Sales' },
    { to: '/customers', icon: FaPeopleGroup, label: 'Agents' },
    { to: '/travel-card-holders', icon: BiCreditCard, label: 'Travel Card Holders' },
    { to: '/tellers', icon: PiHandDeposit, label: 'Tellers' },
    {
      label: 'Tills',
      icon: FaCashRegister,
      children: [
        { to: '/tills/collection-points', label: 'Collection Points' },
        { to: '/tills/sessions', label: 'Sessions' },
      ],
    },
    {
      label: 'Fleet',
      icon: FaBusAlt,
      children: [
        { to: '/fleet/transporters', label: 'Transporters' },
        { to: '/fleet/buses', label: 'Buses' },
        { to: '/fleet/routes', label: 'Routes' },
        { to: '/fleet/validators', label: 'Validators' },
      ],
    },
    {
      label: 'Rosters',
      icon: MdChecklist,
      children: [
        { to: '/rosters/buses', label: 'Buses' },
        { to: '/rosters/validators', label: 'Validators' },
      ],
    },
    {
      label: 'Reports',
      icon: BiSolidReport,
      children: [
        { to: '/reports/daily', label: 'Daily' },
        { to: '/reports/custom', label: 'Custom' },
      ],
    },
  ],

  'FMPS-ACCOUNT-MGR': [
    { to: '/manager', icon: FaThLarge, label: 'Dashboard', end: true },
    { to: '/payments', icon: PiHandDeposit, label: 'Payments' },
    { to: '/invoices', icon: HiOutlineClipboardDocumentList, label: 'Invoices' },
    { to: '/sales/sessions', icon: MdOutlineSell, label: 'Sales' },
    { to: '/travel-card-holders', icon: BiCreditCard, label: 'Travel Card Holders' },
    { to: '/tellers', icon: PiHandDeposit, label: 'Tellers' },
    {
      label: 'Tills',
      icon: FaCashRegister,
      children: [
        { to: '/tills/collection-points', label: 'Collection Points' },
        { to: '/tills/sessions', label: 'Sessions' },
      ],
    },
    { to: '/customers', icon: FaPeopleGroup, label: 'Agents' },
    {
      label: 'Reports',
      icon: BiSolidReport,
      children: [
        { to: '/reports/daily', label: 'Daily' },
        { to: '/reports/custom', label: 'Custom' },
      ],
    },
  ],

  'FMPS-TELLER': [
    { to: '/teller/till', icon: FaCashRegister, label: 'Till', end: true },
    { to: '/payments', icon: PiHandDeposit, label: 'Payments' },
    { to: '/travel-card-holders', icon: BiCreditCard, label: 'Travel Card Holders' },
  ],

  'FMPS-PAYMENT-CLERK': [
    { to: '/sales-rep', icon: HiOutlineClipboardDocumentList, label: 'Invoices', end: true },
    { to: '/rosters/buses', icon: MdChecklist, label: 'Roster' },
    { to: '/sales-rep/payments', icon: PiHandDeposit, label: 'Payments' },
  ],

  'FMPS-AGENT': [
    { to: '/main-agent', icon: RiDashboardLine, label: 'Dashboard', end: true },
    { to: '/main-agent/vouchers', icon: BsCreditCard2Back, label: 'Vouchers' },
    { to: '/main-agent/agents', icon: FaPeopleGroup, label: 'Agents' },
  ],

  'FMPS-GOV': [
    { to: '/slpta', icon: RiDashboardLine, label: 'Dashboard', end: true },
    { to: '/rosters/buses', icon: MdChecklist, label: 'Roster' },
    { to: '/slpta/reports', icon: BiSolidReport, label: 'Reports' },
  ],

  'FMPS-OPS-OFFICER': [
    {
      label: 'Fleet',
      icon: FaBusAlt,
      children: [
        { to: '/operations', label: 'Buses' },
        { to: '/fleet/validators', label: 'Validators' },
      ],
    },
    {
      label: 'Rosters',
      icon: MdChecklist,
      children: [
        { to: '/rosters/buses', label: 'Buses' },
        { to: '/rosters/validators', label: 'Validators' },
      ],
    },
  ],

  'FMPS-OPS-SUPERVISOR': [
    { to: '/ops-supervisor', icon: RiDashboardLine, label: 'Dashboard', end: true },
    { to: '/customers', icon: FaPeopleGroup, label: 'Agents' },
    { to: '/travel-card-holders', icon: BiCreditCard, label: 'Travel Card Holders' },
    { to: '/rosters/buses', icon: MdChecklist, label: 'Rosters' },
    {
      label: 'Reports',
      icon: TbReportAnalytics,
      children: [
        { to: '/reports/daily', label: 'Daily' },
        { to: '/reports/custom', label: 'Custom' },
      ],
    },
  ],

  'FMPS-TRANSPORTER': [
    { to: '/mtc/buses', icon: FaBusAlt, label: 'Buses' },
    { to: '/mtc/schedule', icon: MdChecklist, label: 'Schedule' },
    { to: '/rosters/buses', icon: MdChecklist, label: 'Roster' },
    { to: '/mtc/reports', icon: BiSolidReport, label: 'Reports' },
  ],

  'FMPS-DEMO': [
    { to: '/manager', icon: FaThLarge, label: 'Dashboard', end: true },
    { to: '/payments', icon: PiHandDeposit, label: 'Payments' },
    { to: '/invoices', icon: HiOutlineClipboardDocumentList, label: 'Invoices' },
    { to: '/sales/sessions', icon: MdOutlineSell, label: 'Sales' },
    { to: '/travel-card-holders', icon: BiCreditCard, label: 'Travel Card Holders' },
    { to: '/tellers', icon: PiHandDeposit, label: 'Tellers' },
    {
      label: 'Tills',
      icon: FaCashRegister,
      children: [
        { to: '/tills/collection-points', label: 'Collection Points' },
        { to: '/tills/sessions', label: 'Sessions' },
      ],
    },
    { to: '/customers', icon: FaPeopleGroup, label: 'Agents' },
    {
      label: 'Reports',
      icon: BiSolidReport,
      children: [
        { to: '/reports/daily', label: 'Daily' },
        { to: '/reports/custom', label: 'Custom' },
      ],
    },
  ],
};
